import { getCurrentAdminRbacPermissionsOptions } from '@gozoki/api'
import { createFileRoute, Outlet } from '@tanstack/react-router'
import { ScrollArea } from '~/components/ui/scroll-area'
import { createAllPowerfulAbility, createAppAbility } from '~/utils/ability'
import { AppSidebar } from '../../components/new/navigation/app-sidebar'
import { SidebarInset, SidebarProvider } from '../../components/ui/sidebar'

export const Route = createFileRoute('/_authenticated')({
  component: AuthenticatedLayout,
  beforeLoad: async ({ context }) => {
    const rbacPermissions = await context.queryClient.ensureQueryData(
      getCurrentAdminRbacPermissionsOptions(),
    )

    const ability =
      rbacPermissions.enforcementEnabled === false
        ? createAllPowerfulAbility()
        : createAppAbility(rbacPermissions.grants)

    return { ability }
  },
})

function AuthenticatedLayout() {
  return (
    <div className="h-screen max-h-screen overflow-hidden leading-none">
      <ScrollArea className="h-full" scrollBarClassName="mr-px">
        <SidebarProvider>
          <AppSidebar />
          <SidebarInset className="m-2 overflow-hidden">
            <Outlet />
          </SidebarInset>
        </SidebarProvider>
      </ScrollArea>
    </div>
  )
}
